import React, { useEffect, useState } from "react";
import { SAFE_TOP } from "../kota/ui";
import { useToa } from "../../lib/useToa";
import { ToaPill } from "./ToaPill";

// Spanduk Toa global (dipasang sekali di App): pil meriah meluncur dari atas saat ada toa tayang, hilang saat selesai / diketuk.
export function ToaBanner() {
  const { toa, sisa, tayang } = useToa();
  const [tampil, setTampil] = useState(null);     // toa yang sedang ditampilkan
  const [keluar, setKeluar] = useState(false);
  const [sembunyi, setSembunyi] = useState(null); // id toa yang disembunyikan pengguna
  useEffect(() => {
    if (toa && toa.id !== sembunyi && (!tampil || tampil.id !== toa.id)) { setTampil(toa); setKeluar(false); return; }
    if ((!toa || toa.id === sembunyi) && tampil && !keluar) { setKeluar(true); const t = setTimeout(() => setTampil(null), 420); return () => clearTimeout(t); }
    return undefined;
  }, [toa, sembunyi, tampil, keluar]);
  if (!tampil) return null;
  return (
    <div data-testid="toa-banner" style={{ position: "fixed", left: 10, right: 10, top: `calc(${SAFE_TOP} + 8px)`, display: "flex", justifyContent: "center", zIndex: 80, pointerEvents: "none" }}>
      <div className={keluar ? "toa-keluar" : "toa-masuk"} style={{ pointerEvents: "auto", width: "100%", maxWidth: 400 }}>
        <ToaPill toa={tampil} sisa={tampil.id === toa?.id ? sisa : 0} total={tayang} onClick={() => setSembunyi(tampil.id)} />
      </div>
    </div>
  );
}
